module.exports = __webpack_public_path__ + "img/icon_catalog.bb718ab4.svg";